function bindUnvalidatableInputMaker() {
  return input => {
    return {
      ...input,
      entry: {
        shouldValidate: () => false,
        validate: () => false
      }
    };
  };
}

export { bindUnvalidatableInputMaker };
//# sourceMappingURL=util.make-unvalidatable-input.js.map
